




















































































import Vue from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import {
  ClickUpUrlForGiveFeedbackLink,
  ClickupUrlForRequestFeatureLink
} from '../lib/constants';
import Features from '../lib/featureFlags';
import { isMobile, isTablet, isDesktop } from '../lib/utilities/breakpoints';
import { BillableItem } from '../lib/interfaces/billableItem';

export default Vue.extend({
  name: 'NavigationClientMenu',
  props: {
    dense: Boolean,
    menuItems: Array
  },
  data() {
    return {
      ClickupUrlForRequestFeatureLink,
      ClickUpUrlForGiveFeedbackLink,
      isMenuOpen: false
    };
  },
  computed: {
    ...mapState('user', {
      userName: 'firstName',
      creditsAvailable: 'creditsAvailable',
      userCreatedAt: 'createdAt'
    }),
    ...(mapState('subscription', ['plans']) as {
      plans: () => BillableItem[];
    }),
    ...mapState('client', {
      subscribersCounts: 'subscribersCounts',
      isTelkomClient: 'isTelkomClient',
      messageSendingPhoneNumber: 'messageSendingPhoneNumber',
      subscriptionPlanId: 'subscriptionPlanId'
    }),
    ...mapState('user', ['email', 'clientId']),
    ...mapGetters('user', ['accountManagementAllowed', 'isClientSession']),
    ...mapGetters('client', [
      'isActiveClient',
      'isInternationalClient',
      'isTelkomClient'
    ]),
    ...mapGetters('client', ['client']),

    currentPlan(): BillableItem | undefined {
      return this.plans?.find(({ id }) => id === this.subscriptionPlanId);
    },

    showsTopBar() {
      return this.client.isTestClient || this.isClientSession;
    },

    navHeightClass() {
      return this.showsTopBar ? 'top--100' : 'top--50';
    },

    menuIcon() {
      return this.isLargeNav
        ? 'mdi-menu-down'
        : this.isMenuOpen
        ? 'mdi-close'
        : 'mdi-menu';
    },
    isLargeNav() {
      return isDesktop(this.$vuetify);
    },
    isMidNav() {
      return isTablet(this.$vuetify);
    },

    currentPlanName(): string {
      return this.currentPlan?.name || '';
    },

    numberOfCreditsAvailable(): number {
      return this.creditsAvailable ?? 0;
    },

    numberOfSubscribers() {
      return this.subscribersCounts ?? 0;
    },

    hasPhone(): boolean {
      return !!this.messageSendingPhoneNumber;
    },

    showIntegrationsPage(): boolean {
      return Features.integrationsManagement || this.$auth.isAdmin;
    },
    displayName() {
      const name: string = this.userName || 'Profile';
      return this.dense ? name[0].toUpperCase() : name;
    }
  },

  watch: {
    $route: {
      handler() {
        this.loadCreditsAvailable();
      },
      immediate: true
    }
  },

  methods: {
    ...mapActions('user', ['loadCreditsAvailable', 'adminClientSessionDelete']),

    ...mapState('user', ['id']),

    handleItemClick(item) {
      if (typeof item.click === 'function') {
        item.click();
      }
    },

    menuChange(value) {
      this.isMenuOpen = value;
    }
  }
});
